/*! Audiocity - Verificador de cobertura de envio gratis Vento - v3 2026-09-23
 * Fuente del listado: sonomarcas.com/pages/cobertura-ciudades-envio (Vento S.A.S., NIT 900.124.326), extraido el 2026-09-22.
 * Convierte el texto "ciudades de cobertura de Vento" en un enlace que abre un buscador de ciudad en linea.
 */
(function () {
  'use strict';
  if (window.__acVentoCob) return;

  var RAW = "ANTIOQUIA=ANDES|APARTADO|BARBOSA|BELLO|CALDAS|CAREPA|CAUCASIA|CHIGORODO|CISNEROS|CONCORDIA|COPACABANA|CURRULAO|DON MATIAS|EL CARMEN DE VIBORAL|EL RETIRO|EL SANTUARIO|ENTRERRIOS|ENVIGADO|GIRARDOTA|GRANADA|GUARNE|ITAGUI|LA CEJA|LA ESTRELLA|LA UNION|MARINILLA|MEDELLIN|NECOCLI|RIONEGRO|SABANETA|SAN ANTONIO DE PRADO|SAN CRISTOBAL|SAN JUAN DE URABA|SANTA ELENA|SANTA ROSA DE OSOS|SANTA FE DE ANTIOQUIA|SANTUARIO|SONSON|TURBO|URRAO|YARUMAL|YOLOMBO\nARAUCA=ARAUCA\nATLÁNTICO=BARANOA|BARRANQUILLA|CARRETO|GALAPA|JUAN DE ACOSTA|MALAMBO|PONEDERA|PUERTO COLOMBIA|SABANAGRANDE|SABANALARGA|SOLEDAD\nBOGOTÁ, D. C.=BOGOTÁ, D. C.\nBOLÍVAR=ARJONA|CARTAGENA|EL CARMEN DE BOLIVAR|MAGANGUE|SAN JUAN NEPOMUCENO|SAN PABLO|SANTA ROSA DEL SUR|TURBACO\nBOYACÁ=AQUITANIA|ARCABUCO|CHIQUINQUIRA|DUITAMA|MIRAFLORES|MONIQUIRA|NOBSA|PAIPA|PUERTO BOYACA|RAMIRIQUI|RAQUIRA|SABOYA|SACHICA|SAMACA|SANTAMARIA|SANTA ROSA DE VITERBO|SOGAMOSO|TENZA|TIBASOSA|TUNJA|TUTA|VENTAQUEMADA|VILLA DE LEYVA\nCALDAS=AGUADAS|ANSERMA|ARANZAZU|ARAUCA|BELALCAZAR|CHINCHINA|FILADELFIA|FLORENCIA|LA DORADA|LA FELISA|LA MANUELA|MANIZALES|MANZANARES|MARMATO|MARQUETALIA|NEIRA|NORCASIA|PACORA|PALESTINA|PENSILVANIA|RIOSUCIO|RISARALDA|SALAMINA|SAN JOSE|SAN JUAN DE MARMATO|SAN LORENZO|SANTAGUEDA|SUPIA|VICTORIA|VILLA MARIA|VITERBO\nCAQUETÁ=CARTAGENA DEL CHAIRA|EL DONCELLO|EL PAUJIL|FLORENCIA|PUERTO RICO|SAN JOSE DE LA FRAGUA|SAN VICENTE DEL CAGUAN\nCASANARE=AGUAZUL|HATO COROZAL|MANI|MONTERREY|OROCUE|PAZ DE ARIPORO|PORE|SAN LUIS DE PALENQUE|TAURAMENA|TRINIDAD|VILLA CAROLA|VILLANUEVA|YOPAL\nCAUCA=ARGELIA|BALBOA|BOLIVAR|BUENOS AIRES|CAJIBIO|CALDONO|CALOTO|CORINTO|EL BORDO|EL ESTRECHO|EL MANGO|FLORENCIA|GALINDEZ|GUACHENE|INGENIOS CAUCA|LIMONES DEL PATIA|MIRANDA|MONDOMO|MORALES|PADILLA|PARQUE SUR VILLA RICA|PATIA|PESCADOR|PIEDRA SENTADA|PIENDAMO|POPAYAN|PUERTO TEJADA|ROSAS|SANTANDER DE QUILICHAO|SIBERIA|SILVIA|SUAREZ|TIMBA|TIMBIO|TUNIA|VILLARICA\nCESAR=AGUACHICA|BOSCONIA|SANALBERTO|VALLEDUPAR\nCHOCÓ=ANIMAS|CERTEGUI|ISTMINA|QUIBDO|TADO|UNION PANAMERICANA|YUTO\nCÓRDOBA=MONTERÍA|CERETÉ|CIENAGA DE ORO|PLANETA RICA|PUEBLO NUEVO|SAHAGÚN|SAN ANTERO\nCUNDINAMARCA=AGUA DE DIOS|ANAPOIMA|ANOLAIMA|APULO|ARBELAEZ|BRICENO|CAJICA|CAPARRAPI|CAQUEZA|CHIA|CHINAUTA|CHIPAQUE|CHOACHI|CHOCONTA|COGUA|COTA|CUCUNUBA|EL COLEGIO|EL ROSAL|FACATATIVA|FUNZA|FUSAGASUGA|GACHANCIPA|GIRARDOT|GRANADA|GUADUAS|GUASCA|LA CALERA|LA MESA|LA VEGA|LENGUAZAQUE|MADRID|MEDINA|MOSQUERA|NEMOCON|NILO|PACHO|PARATE BUENO|PASCA|PUERTO SALGAR|QUETAME|RICAURTE|SASAIMA|SESQUILE|SIBATE|SILVANIA|SIMIJACA|SOACHA|SOPO|SUBACHOQUE|SUSA|TABIO|TENJO|TOCAIMA|TOCANCIPA|UBATE|VILLA DE SAN DIEGO DE UBATE|VILLAPINZON|VILLETA|VIOTA|ZIPAQUIRA\nGUAVIARE=SAN JOSE DEL GUAVIARE\nHUILA=ACEVEDO|AGRADO|AIPE|ALGECIRAS|ALTAMIRA|CAMPO ALEGRE|EL PITAL|GARZON|GIGANTE|GUADALUP|HOBO|LA ARGENTINA|LA PLATA|NEIVA|PAICOL|PALERMO|PALESTINA|PITAL|PITALITO|RIVERA|SAN AGUSTIN|SAN JOSE DE ISNOS|SUAZA|TARQUI|TESALIA|TIMANA|TRES ESQUINAS|YAGUARA\nMAGDALENA=CIENAGA|FUNDACION|SANTAMARTA\nMETA=ACACIAS|BARRANCA DE UPIA|CASTILLA LA NUEVA|CUBARRAL|CUMARAL|EL CASTILLO|FUENTE DE ORO|GRANADA|GUAMAL|LEJANIAS|MESETAS|PUERTO GAITAN|PUERTO LOPEZ|RESTREPO|SAN CARLOS DE GUAROA|SAN JUAN DEARAMA|SAN MARTIN|VILLAVICENCIO\nNARIÑO=ALDANA|ALTAQUER|BARBACOAS|BELEN|BUESACO|CATAMBUCO|CHACHAGUI|CONSACA|CORDOBA|CUMBAL|EL ESPINO|EL TAMBO|GENOY|GUACHUCAL|GUAITARILLA|IPIALES|LA CRUZ|LA ESPRIELLA|LA FLORIDA|LA UNION|LAS LAJAS|LINARES|LLORENTE|NARIÑO|PASTO|PEDREGAL|PIEDRANCHA|PINZON|PUERRES|PUPIALES|RICAURTE|SAMANIEGO|SAN BERNARDO|SAN JOSE DE ALBAN|SAN JUAN DE PASTO|SAN PABLO|SANDONA|TANGUA|TUMACO|TUQUERRES|TUTACHAG BAJO|YACUANQUER\nNORTE DE SANTANDER=ABREGO|CHINACOTA|CUCUTA|LOS PATIOS|OCAÑA|PAMPLONA|VILLA DEL ROSARIO\nQUINDÍO=ARMENIA|BARCELONA|BUENAVISTA|CALARCA|CIRCASIA|CORDOBA|FILANDIA|GENOVA|LA TEBAIDA|LA VIRGINIA|MONTENEGRO|PIJAO|PUEBLO TAPADO|QUIMBAYA|SALENTO\nRISARALDA=ALTAGRACIA|APIA|ARABIA|BALBOA|BELEN DE UMBRIA|CERRITOS|DOSQUEBRADAS|GUATICA|INGENIOS RISARALDA|IRRA|LA CELIA|LA FLORIDA|LA VIRGINIA|MARSELLA|MISTRATO|PEREIRA|PUEBLO RICO|QUINCHIA|SANCLEMENTE|SANTA ROSA DE CABAL\nSANTANDER=ARATOCA|BARBOSA|BARICHARA|BARRANCABERMEJA|BUCARAMANGA|CIMITARRA|CURITI|EL PLAYON|FLORIDABLANCA|GIRON|GUEPSA|LA ESPERANZA|LEBRIJA|MALAGA|OIBA|OLIVAL|PIEDECUESTA|PINCHOTE|PUENTE NACIONAL|PUERTO WILCHES|RIONEGRO|SABANA DE TORRES|SAN GIL|SAN VICENTE DE CHUCURI|SOCORRO|VADOREAL|VALLE DE SANJOSE|VELEZ|VILLANUEVA|ZAPATOCA\nSUCRE=ALVARADO|AMBALEMA|SAMPUES|SINCELEJO\nTOLIMA=ALCALA|ALPUJARRA|ALVARADO|AMAIME|AMBALEMA|ANDALUCIA|ANZOATEGUI|ARMERO GUAYABAL|ATACO|CAJAMARCA|CARMEN DE APICALA|CASTILLA|CHAPARRAL|CHICORAL|COELLO|CONVENIO|COYAIMA|CUNDAY|DOLORES|ESPINAL|FALAN|FLANDES|FRESNO|GAITANIA|GUALANDAY|GUAMO|GUAYABAL|HONDA|IBAGUE|ICONONZO|LERIDA|LIBANO|MARIQUITA|MELGAR|NATAGAIMA|ORTEGA|PALO CABILDO|PAYANDE|PICALENA|PIEDRAS|PLANADAS|PRADO|PURIFICACION|RIOBLANCO|ROVIRA|SALDANA|SAN ANTONIO|SAN LUIS|SANTIAGO PEREZ|SUAREZ|TOLEMAIDA|VENADILLO\nVALLE DEL CAUCA=ALCALA|AMAIME|ANDALUCIA|ANSERMANUEVO|BITACO|BOLIVAR|BUENAVENTURA|BUGA|BUGA LA GRANDE|CAICEDONIA|CALI|CANDELARIA|CARTAGO|CAVASA|CISNEROS|DAGUA|DAPA|DARIEN|EL BOLO|EL CARMELO|EL CARMEN|EL CERRITO|EL DOVIO|EL PALMAR|EL PLACER|EL QUEREMAL|EL SALADITO|FELIDIA|FLORIDA|GINEBRA|GUACARI|GUADALAJARA DE BUGA|INGENIO CARMELITA|INGENIO CASTILLA|INGENIO LA CABANA|INGENIO MANUELITA|INGENIO MARIA LUISAS.A|INGENIO MAYAGUEZ|INGENIO PICHICHI|INGENIO PROVIDENCIA|INGENIO RIOPAILA|INGENIO SANCARLOS|JAMUNDI|KILOMETRO 30|LA BUITRERA|LA CUMBRE|LA MARINA|LA PAILA|LA UNION|LA URIBE|LA VICTORIA|LOBO GUERRERO|MEDIACANOA|MUELLES BUENAVENTURA|OBANDO|PALMIRA|PASO DE LA BOLSA|PAVAS|POTRERILLO|PRADERA|PUENTE TIERRA|QUINAMAYO|RESTREPO|RIOFRIO|ROLDANILLO|ROZO|SAN ANTONIO DE LOS CABALLEROS|SAN MARCOS|SAN PEDRO|SANTA ELENA|SEVILLA|SONSO|TABLONES|TORO|TRUJILLO|TULUA|ULLOA|VERSALLES|VIJES|VILLAGORGONA|YOTOCO|YUMBO|ZARAGOZA|ZARZAL";
  var WA = '573017949887';
  var MIN = 600000;
  var RX = /ciudades de cobertura de Vento(?: S\.A\.S)?/i;

  var ALIAS = {
    bogota: 'BOGOTÁ, D. C.', santafedebogota: 'BOGOTÁ, D. C.', bogotadistritocapital: 'BOGOTÁ, D. C.',
    cartagenadeindias: 'CARTAGENA', sanjosedecucuta: 'CUCUTA', santiagodecali: 'CALI',
    villadeleiva: 'VILLA DE LEYVA', sanjuandeuraba: 'SAN JUAN DE URABA', santafedeantioquia: 'SANTA FE DE ANTIOQUIA'
  };

  function norm(s) {
    s = String(s || '');
    if (s.normalize) s = s.normalize('NFD');
    return s.replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cop(n) {
    try { return '$' + new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 }).format(n); }
    catch (e) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  }
  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var p = [], i, j;
    for (j = 0; j <= b.length; j++) p[j] = j;
    for (i = 1; i <= a.length; i++) {
      var prev = p[0]; p[0] = i;
      for (j = 1; j <= b.length; j++) {
        var tmp = p[j];
        p[j] = Math.min(p[j] + 1, p[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
        prev = tmp;
      }
    }
    return p[b.length];
  }

  var DATA = RAW.split('\n').map(function (l) {
    var p = l.split('=');
    return { d: p[0], k: norm(p[0]), c: p[1].split('|') };
  });
  var IDX = [];
  DATA.forEach(function (g) { g.c.forEach(function (c) { IDX.push({ c: c, d: g.d, k: norm(c) }); }); });

  function group(list) {
    // agrupa entradas con el mismo nombre de ciudad: { c, ds:[deps] }
    var out = [], seen = {};
    list.forEach(function (e) {
      if (seen[e.c]) { if (seen[e.c].ds.indexOf(e.d) < 0) seen[e.c].ds.push(e.d); return; }
      seen[e.c] = { c: e.c, ds: [e.d] }; out.push(seen[e.c]);
    });
    return out;
  }

  function search(q) {
    var k = norm(q), r = { k: k, exact: [], sug: [], dep: null };
    if (k.length < 2) return r;
    var al = ALIAS[k];
    r.exact = group(IDX.filter(function (e) { return e.k === k || e.k === k + 'dc' || (al && e.c === al); }));
    r.dep = DATA.filter(function (g) { return g.k === k; })[0] ||
      (k.length >= 5 ? DATA.filter(function (g) { return g.k.indexOf(k) === 0; })[0] : null) || null;
    if (!r.exact.length) {
      var sc = [];
      IDX.forEach(function (e) {
        var s = 0;
        if (e.k.indexOf(k) === 0) s = 4;
        else if (k.length >= 3 && e.k.indexOf(k) > 0) s = 3;
        else if (e.k.length >= 4 && k.indexOf(e.k) === 0) s = 2;
        else if (k.length >= 5 && lev(k, e.k) <= (k.length >= 8 ? 2 : 1)) s = 1;
        if (s) sc.push({ e: e, s: s });
      });
      sc.sort(function (a, b) { return b.s - a.s || a.e.c.localeCompare(b.e.c, 'es'); });
      r.sug = group(sc.map(function (x) { return x.e; })).slice(0, 8);
    }
    return r;
  }

  function productInfo() {
    var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!m) return null;
    var vid = null;
    try { vid = new URLSearchParams(location.search).get('variant'); } catch (e) {}
    var v = (m.variants || []).filter(function (x) { return String(x.id) === String(vid); })[0] || (m.variants || [])[0];
    var h = document.querySelector('main h1') || document.querySelector('h1');
    var t = document.querySelector('meta[property="og:title"]');
    var title = (h && h.textContent.replace(/\s+/g, ' ').trim()) || (t && t.content) || document.title;
    title = title.replace(/\s*[|\u2013\u2014-]\s*Audiocity\s*$/i, '');
    return {
      vento: /^vento$/i.test(String(m.vendor || '').trim()),
      price: v && typeof v.price === 'number' ? v.price / 100 : null,
      title: title
    };
  }

  function waUrl(city) {
    var p = productInfo();
    var txt = 'Hola Audiocity, quiero cotizar el envío' + (p ? ' de: ' + p.title : '') +
      (city ? ' con destino a ' + city : '') + ' - ' + location.origin + location.pathname;
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(txt);
  }

  function priceNote() {
    var p = productInfo();
    if (!p) return '';
    if (!p.vento) return 'Aplica solo a productos marca Vento.';
    if (p.price == null) return '';
    if (p.price > MIN) return 'Este producto por sí solo ya supera el monto mínimo.';
    return 'Este producto cuesta ' + cop(p.price) + ': complete más de ' + cop(MIN) + ' en productos Vento para acceder al envío gratis.';
  }

  var CSS = [
    'a.acv-link.acv-link{-webkit-appearance:none;appearance:none;background:linear-gradient(transparent 58%,var(--ac-azul-bruma,#E4F1F8) 58%);border:0;border-radius:2px;padding:0 1px;margin:0;font:inherit;font-weight:600;color:var(--ac-azul-texto,#0670A0);text-decoration:underline;text-decoration-thickness:1.5px;text-underline-offset:3px;cursor:pointer;display:inline;-webkit-box-decoration-break:clone;box-decoration-break:clone;text-align:left;line-height:inherit;letter-spacing:inherit;min-height:0;min-width:0;box-shadow:none;height:auto;width:auto}',
    'a.acv-link.acv-link:hover{color:var(--ac-azul-oscuro,#05628A);background:var(--ac-azul-bruma,#E4F1F8)}',
    'a.acv-link.acv-link:focus-visible{outline:2px solid var(--ac-azul,#0673A0);outline-offset:2px}',
    'a.acv-link.acv-link::after{content:"";display:inline-block;width:.95em;height:.95em;margin-left:.3em;vertical-align:-.12em;background:currentColor;-webkit-mask:var(--acv-ico) center/contain no-repeat;mask:var(--acv-ico) center/contain no-repeat}',
    'a.acv-link.acv-link{--acv-ico:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272.2%27 stroke-linecap=%27round%27%3E%3Ccircle cx=%2711%27 cy=%2711%27 r=%277%27/%3E%3Cpath d=%27M20 20l-3.5-3.5%27/%3E%3C/svg%3E")}',
    'a.acv-link.acv-link[aria-expanded="true"]{--acv-ico:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272.4%27 stroke-linecap=%27round%27%3E%3Cpath d=%27M6 15l6-6 6 6%27/%3E%3C/svg%3E")}',
    '.acv-panel{grid-column:1/-1;box-sizing:border-box;width:100%;margin:10px 0 4px;padding:14px;background:#fff;border:1px solid var(--ac-bruma,#E1E8EE);border-radius:12px;box-shadow:0 6px 18px rgba(11,22,32,.06);font-family:"IBM Plex Sans","Segoe UI",system-ui,sans-serif;font-size:14px;line-height:1.45;color:var(--ac-tinta,#0E1A24);text-align:left}',
    '.acv-panel *{box-sizing:border-box}',
    '.acv-panel[hidden]{display:none}',
    '.acv-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 0 6px}',
    '.acv-eyebrow{margin:0;font-family:"IBM Plex Mono",ui-monospace,monospace;font-size:11px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;color:var(--ac-azul-texto,#0670A0)}',
    '.acv-x{-webkit-appearance:none;appearance:none;border:0;background:transparent;color:var(--ac-acero,#66768A);width:28px;height:28px;min-height:0;padding:0;border-radius:50%;cursor:pointer;font-size:20px;line-height:28px;text-align:center}',
    '.acv-x:hover{background:var(--ac-niebla,#F4F7F9);color:var(--ac-tinta,#0E1A24)}',
    '.acv-label{display:block;margin:0 0 8px;font-weight:600;font-size:14px;color:var(--ac-tinta,#0E1A24)}',
    '.acv-field{position:relative}',
    '.acv-field::before{content:"";position:absolute;left:12px;top:50%;width:16px;height:16px;margin-top:-8px;background:var(--ac-acero,#66768A);-webkit-mask:var(--acv-pin) center/contain no-repeat;mask:var(--acv-pin) center/contain no-repeat;pointer-events:none}',
    '.acv-field{--acv-pin:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M12 21s-7-6.1-7-11.5A7 7 0 0 1 19 9.5C19 14.9 12 21 12 21z%27/%3E%3Ccircle cx=%2712%27 cy=%279.5%27 r=%272.5%27/%3E%3C/svg%3E")}',
    '.acv-panel input.acv-q{display:block;width:100%;height:44px;margin:0;padding:0 12px 0 36px;border:1px solid #C5D2DB;border-radius:8px;background:#fff;color:var(--ac-tinta,#0E1A24);font:inherit;font-size:16px;box-shadow:none;outline:0}',
    '.acv-panel input.acv-q:focus{border-color:var(--ac-azul,#0673A0);box-shadow:0 0 0 3px rgba(6,115,160,.15)}',
    '.acv-panel input.acv-q::placeholder{color:#8795A3;opacity:1}',
    '.acv-out:empty{display:none}',
    '.acv-out{margin-top:10px}',
    '.acv-res{padding:10px 12px;border-radius:8px;border-left:3px solid}',
    '.acv-res p{margin:0}',
    '.acv-res p+p{margin-top:4px}',
    '.acv-res--ok{background:#EAF6EF;border-color:#1E8A4C;color:#14532D}',
    '.acv-res--no{background:#FFF6E5;border-color:#D98A00;color:#5C3A00}',
    '.acv-res--hint{background:var(--ac-azul-niebla,#F2F8FB);border-color:var(--ac-azul,#0673A0);color:var(--ac-grafito,#33434F)}',
    '.acv-res strong{font-weight:700}',
    '.acv-small{font-size:12.5px;opacity:.9}',
    '.acv-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px}',
    '.acv-chip{-webkit-appearance:none;appearance:none;display:inline-flex;align-items:baseline;gap:4px;min-height:0;height:auto;padding:5px 9px;border:1px solid var(--ac-bruma,#E1E8EE);border-radius:999px;background:#fff;color:var(--ac-tinta,#0E1A24);font:inherit;font-size:12.5px;line-height:1.2;cursor:pointer;text-align:left}',
    '.acv-chip:hover{border-color:var(--ac-azul,#0673A0);color:var(--ac-azul-texto,#0670A0)}',
    '.acv-chip span{font-size:10.5px;color:var(--ac-acero,#66768A);letter-spacing:.03em}',
    '.acv-wa{display:inline-flex;align-items:center;gap:8px;margin-top:10px;padding:9px 14px;border-radius:8px;background:#fff;border:1px solid #C5D2DB;color:var(--ac-tinta,#0E1A24)!important;font-weight:600;font-size:13.5px;text-decoration:none!important}',
    '.acv-wa:hover{border-color:#1FA855}',
    '.acv-wa svg{width:18px;height:18px;flex:0 0 18px;color:#1FA855}',
    '.acv-all{margin-top:12px;border-top:1px solid var(--ac-bruma,#E1E8EE);padding-top:10px}',
    '.acv-all>summary{cursor:pointer;list-style:none;font-weight:600;font-size:13.5px;line-height:1.4;color:var(--ac-azul-texto,#0670A0);display:block;padding:2px 0}',
    '.acv-all>summary::-webkit-details-marker{display:none}',
    '.acv-all>summary::before{content:"";display:inline-block;width:7px;height:7px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(-45deg);transition:transform .15s;margin:0 9px 2px 2px;vertical-align:middle}',
    '.acv-all[open]>summary::before{transform:rotate(45deg)}',
    '.acv-all>summary span{font-weight:400;color:var(--ac-acero,#66768A)}',
    '.acv-list{max-height:320px;overflow:auto;margin-top:8px;padding-right:4px;overscroll-behavior:contain}',
    '.acv-dep{padding:8px 6px;border-bottom:1px dashed var(--ac-bruma,#E1E8EE);border-radius:6px}',
    '.acv-dep:last-child{border-bottom:0}',
    '.acv-dep h4{margin:0 0 3px;font-family:"IBM Plex Mono",ui-monospace,monospace;font-size:11px;font-weight:500;letter-spacing:.06em;color:var(--ac-azul-texto,#0670A0)}',
    '.acv-dep h4 span{color:var(--ac-acero,#66768A)}',
    '.acv-dep p{margin:0;font-size:12px;line-height:1.55;color:var(--ac-grafito,#33434F)}',
    '.acv-dep.is-hit{background:var(--ac-azul-bruma,#E4F1F8)}',
    '.acv-depbtn{-webkit-appearance:none;appearance:none;background:none;border:0;padding:0;min-height:0;height:auto;font:inherit;font-weight:600;color:var(--ac-azul-texto,#0670A0);text-decoration:underline;text-underline-offset:2px;cursor:pointer;text-align:left}',
    '.acv-list{position:relative}',
    '.acv-foot{margin:10px 0 0;font-size:11.5px;line-height:1.4;color:var(--ac-acero,#66768A)}'
  ].join('\n');

  var WA_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.7a2.8 2.8 0 0 0 1.8-1.3 2.3 2.3 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3z"/></svg>';

  var uid = 0;

  function injectCss() {
    if (document.getElementById('acv-style')) return;
    var st = document.createElement('style');
    st.id = 'acv-style';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function cityLine(g) {
    return '<strong>' + esc(g.c) + '</strong> <span class="acv-small">(' + esc(g.ds.join(' · ')) + ')</span>';
  }

  function chip(c, d) {
    return '<button type="button" class="acv-chip" data-c="' + esc(c) + '" data-d="' + esc(d) + '">' + esc(c) + ' <span>' + esc(d) + '</span></button>';
  }

  function depBtn(dep) {
    return '<p class="acv-small" style="margin-top:8px"><button type="button" class="acv-depbtn" data-dep="' + dep.k + '">Ver los ' + dep.c.length + ' municipios con cobertura en ' + esc(dep.d) + '</button></p>';
  }

  function renderOk(out, groups, dep) {
    var note = priceNote();
    var many = groups.length > 1 || groups[0].ds.length > 1;
    out.innerHTML = '<div class="acv-res acv-res--ok">' +
      '<p>✓ Sí hay envío gratis a ' + groups.map(cityLine).join(', ') + '</p>' +
      '<p class="acv-small">En compras de productos Vento superiores a ' + cop(MIN) + '.' + (note ? ' ' + esc(note) : '') + '</p>' +
      (many ? '<p class="acv-small">Hay varios municipios con ese nombre: verifique que coincida su departamento.</p>' : '') +
      (dep ? depBtn(dep) : '') +
      '</div>';
  }

  function renderNo(out, q) {
    out.innerHTML = '<div class="acv-res acv-res--no">' +
      '<p>No encontramos <strong>' + esc(q) + '</strong> en la zona de cobertura de Vento.</p>' +
      '<p class="acv-small">Igual despachamos a toda Colombia: para su ciudad el flete se acuerda con un asesor.</p>' +
      '<a class="acv-wa" target="_blank" rel="noopener" href="' + esc(waUrl(q)) + '">' + WA_SVG + 'Cotizar el envío por WhatsApp</a>' +
      '</div>';
  }

  function renderSug(out, r, q) {
    var html = '<div class="acv-res acv-res--hint">';
    if (r.sug.length) {
      html += '<p>¿Se refiere a alguno de estos?</p><div class="acv-chips">' +
        r.sug.map(function (g) { return chip(g.c, g.ds.join(' · ')); }).join('') + '</div>';
      if (r.dep) html += depBtn(r.dep);
    } else if (r.dep) {
      html += '<p>En <strong>' + esc(r.dep.d) + '</strong> hay envío gratis a ' + r.dep.c.length + (r.dep.c.length === 1 ? ' municipio:' : ' municipios y localidades:') + '</p>' +
        '<div class="acv-chips">' + r.dep.c.map(function (c) { return chip(c, r.dep.d); }).join('') + '</div>';
    }
    html += '<p class="acv-small" style="margin-top:8px">¿No aparece? <a href="' + esc(waUrl(q)) + '" target="_blank" rel="noopener" style="color:inherit;font-weight:600">Consulte el flete por WhatsApp</a>.</p>';
    out.innerHTML = html + '</div>';
  }

  function renderList(body) {
    if (body.getAttribute('data-ok')) return;
    body.innerHTML = '<div class="acv-list">' + DATA.map(function (g) {
      return '<div class="acv-dep" data-k="' + g.k + '"><h4>' + esc(g.d) + ' <span>· ' + g.c.length + '</span></h4><p>' + g.c.map(esc).join(' · ') + '</p></div>';
    }).join('') + '</div>';
    body.setAttribute('data-ok', '1');
  }

  function buildPanel(id) {
    var el = document.createElement('div');
    el.className = 'acv-panel';
    el.id = id;
    el.hidden = true;
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Verificador de envío gratis Vento');
    el.innerHTML =
      '<div class="acv-head"><p class="acv-eyebrow">Envío gratis Vento</p><button type="button" class="acv-x" aria-label="Cerrar verificador">×</button></div>' +
      '<label class="acv-label" for="' + id + '-q">¿Su ciudad o municipio tiene envío gratis?</label>' +
      '<div class="acv-field"><input class="acv-q" id="' + id + '-q" type="search" autocomplete="off" autocapitalize="words" spellcheck="false" enterkeyhint="search" placeholder="Escriba su ciudad o municipio"></div>' +
      '<div class="acv-out" aria-live="polite"></div>' +
      '<details class="acv-all"><summary>Ver todas las ciudades con cobertura <span>(' + DATA.length + ' departamentos)</span></summary><div class="acv-all__body"></div></details>' +
      '<p class="acv-foot">Listado de cobertura de Vento S.A.S. Aplica a productos marca Vento en compras superiores a ' + cop(MIN) + '. Fuera de cobertura, el flete se acuerda con un asesor.</p>';

    var input = el.querySelector('.acv-q');
    var out = el.querySelector('.acv-out');
    var all = el.querySelector('.acv-all');
    var body = el.querySelector('.acv-all__body');
    var last = null, t = null;

    function run() {
      var q = input.value.trim();
      var r = search(q);
      last = r;
      if (r.k.length < 2) { out.innerHTML = ''; mark(null); return; }
      if (r.exact.length) renderOk(out, r.exact, r.dep);
      else if (r.dep || r.sug.length) renderSug(out, r, q);
      else renderNo(out, q);
      mark(r.dep ? r.dep.k : (r.exact.length ? norm(r.exact[0].ds[0]) : null));
    }
    function mark(depKey) {
      if (!body.getAttribute('data-ok')) return;
      var hits = body.querySelectorAll('.acv-dep');
      for (var i = 0; i < hits.length; i++) hits[i].classList.toggle('is-hit', !!depKey && hits[i].getAttribute('data-k') === depKey);
    }

    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 120); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault(); clearTimeout(t); run();
        var first = out.querySelector('.acv-chip');
        if (last && !last.exact.length && last.sug.length && first) first.click();
      }
    });
    function openDep(k) {
      all.open = true;
      renderList(body);
      mark(k);
      var list = body.querySelector('.acv-list');
      var d = body.querySelector('.acv-dep[data-k="' + k + '"]');
      if (list && d) list.scrollTop = d.offsetTop;
    }
    out.addEventListener('click', function (e) {
      var db = e.target.closest ? e.target.closest('.acv-depbtn') : null;
      if (db) { openDep(db.getAttribute('data-dep')); return; }
      var b = e.target.closest ? e.target.closest('.acv-chip') : null;
      if (!b) return;
      var c = b.getAttribute('data-c');
      input.value = c;
      var groups = group(IDX.filter(function (x) { return x.c === c; }));
      renderOk(out, groups);
      mark(norm(groups[0].ds[0]));
      input.focus();
    });
    all.addEventListener('toggle', function () { if (all.open) { renderList(body); if (last) mark(last.dep ? last.dep.k : (last.exact.length ? norm(last.exact[0].ds[0]) : null)); } });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(el); }
    });
    el.querySelector('.acv-x').addEventListener('click', function () { close(el); });
    return el;
  }

  function close(panel) {
    panel.hidden = true;
    var btn = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  }

  function toggle(btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) {
      panel = buildPanel(btn.getAttribute('aria-controls'));
      var host = btn.closest('li, p, dd, td') || btn.parentNode;
      if (host.tagName === 'LI') host.appendChild(panel);
      else host.parentNode.insertBefore(panel, host.nextSibling);
    }
    var open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var q = panel.querySelector('.acv-q');
      setTimeout(function () {
        try { q.focus({ preventScroll: true }); } catch (e) { q.focus(); }
        var r = panel.getBoundingClientRect();
        if (r.bottom > window.innerHeight) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 30);
    }
  }

  function enhance(root) {
    root = root || document.body;
    if (!root || !document.createTreeWalker) return 0;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!RX.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || p.closest('a, button, script, style, textarea, input, select, .acv-panel, [contenteditable="true"], head, title, noscript')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      var m = RX.exec(node.nodeValue);
      if (!m) return;
      var after = node.splitText(m.index);
      after.splitText(m[0].length);
      var id = 'acv-p' + (++uid);
      var b = document.createElement('a');
      b.href = '#cobertura-vento';
      b.setAttribute('role', 'button');
      b.className = 'acv-link';
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-controls', id);
      b.title = 'Verificar si su ciudad tiene envío gratis';
      b.textContent = m[0];
      after.parentNode.replaceChild(b, after);
    });
    return nodes.length;
  }

  function init() {
    injectCss();
    enhance(document.body);
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.acv-link') : null;
      if (!b) return;
      e.preventDefault();
      toggle(b);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      var b = e.target && e.target.classList && e.target.classList.contains('acv-link') ? e.target : null;
      if (!b) return;
      e.preventDefault();
      toggle(b);
    });
    if (/^#(cobertura-vento|ciudades-vento)$/i.test(location.hash)) {
      var first = document.querySelector('.acv-link');
      if (first) { toggle(first); setTimeout(function () { first.scrollIntoView({ block: 'center' }); }, 60); }
    }
    if (window.MutationObserver) {
      var tm = null;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length && !(muts[i].target.closest && muts[i].target.closest('.acv-panel'))) {
            clearTimeout(tm); tm = setTimeout(function () { enhance(document.body); }, 150); return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.__acVentoCob = { v: 3, search: search, enhance: enhance, count: IDX.length };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
